import React from "react";

const Official = ({ row }) => {
  return (
    <>
      {row.costOfficial === "" ? (
        ""
      ) : (
        <div>
          <div>{row.costOfficial?.cashCostOfficial?.toLocaleString()}</div>
          <div>{row.costOfficial?.ccCostOfficial?.toLocaleString()}</div>
          <div>{row.costOfficial?.eccCostOfficial?.toLocaleString()}</div>
          <div>0</div>
          <div>{row.costOfficial?.compCostOfficial?.toLocaleString()}</div>
          <div>
            {row?.costOfficial?.eliteCostOfficial
              ? row?.costOfficial?.eliteCostOfficial?.toLocaleString()
              : 0}
          </div>

          <div style={{ borderTop: "1px dashed black" }}>
            <p>{row?.costOfficial?.serviceCostOfficialSum?.toLocaleString()}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Official;
